import { HeatpumpIo, IoInterfaces, IoInterfaceType } from '../forms'

/**
 * Gets the current IO devices of an installation and return an array of device types
 * that can still be added to installation without surpasing the device limit.
 * @returns Record of I/O devices that can be added to the installation.
 * (Heatpump is excluded and is handled in the getIsHeatpumpAvailable function)
 */
export const getAvailableIo = (ioInterfaces: IoInterfaces, heatpump: HeatpumpIo | null, isGerman: boolean): Record<IoInterfaceType, boolean> => {
  const { htc320h, storage, mypv } = ioInterfaces

  if (isGerman) {
    /**
     * German  installations are allowed an HTC230H device along
     * with one more SG-READY device (storage or heatpump)
     */
    const availableIo: Record<IoInterfaceType, boolean> = {
      htc320h: !htc320h,
      storage: !storage && !heatpump,
      mypv: !mypv,
    }

    return availableIo
  }

  const availableIo: Record<IoInterfaceType, boolean> = {
    htc320h: !htc320h && !storage && !heatpump,
    storage: !htc320h && !storage && !heatpump,
    mypv: !mypv,
  }

  return availableIo
}

export const hasAvailableIo = (availableIo: Record<IoInterfaceType, boolean>): boolean => {
  return Object.values(availableIo).some(option => option)
}

/**
 * Gets the current IO devices of an installation and returns true if a heatpump
 * can still be added to the installation without surpasing the device limit.
 */
export const getIsHeatpumpAvailable = (ioInterfaces: IoInterfaces, heatpump: HeatpumpIo | null, isGerman: boolean): boolean => {
  const { htc320h, storage } = ioInterfaces

  if (isGerman) {
    /**
     * German  installations are allowed an HTC230H device along
     * with one more SG-READY device (storage or heatpump)
     */
    return !storage && !heatpump
  }

  return !htc320h && !storage && !heatpump
}
